import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProjectService } from '../../../services/project.service';
import { ImageBannerComponent } from "../../../components/image-banner/image-banner.component";
import { KeyMetricsComponent } from "../../../components/key-metrics/key-metrics.component";
import { PhotoGalleryComponent } from "../../../components/photo-gallery/photo-gallery.component";
import { SeatBeltComponent } from "../../../components/seat-belt/seat-belt.component";
import { ProjectCardComponent } from "../../../components/project-card/project-card.component";
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'pc-project-template',
  standalone: true,
  imports: [
    ImageBannerComponent, 
    KeyMetricsComponent, 
    PhotoGalleryComponent, 
    SeatBeltComponent, 
    ProjectCardComponent,
  ],
  templateUrl: './project-template.component.html',
  styleUrl: './project-template.component.scss'
})
export class ProjectTemplateComponent implements OnInit {
  project: any;

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private router: Router,
    private metaService: MetaService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const projectId = params.get('id');
      this.loadProject(projectId);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  loadProject(projectId: string | null): void {
    if (!projectId) return;

    this.projectService.getProjects().subscribe(projects => {
      this.project = projects.find((p: any) => p.id === projectId);

      if (this.project) {
        this.metaService.setProjectMetadata(this.project);
      }
    });
  }
}